export const SCOPE_TYPES = { STORES: 'stores', WAREHOUSES: 'warehouses' }

export const ACTION_STYLES = {
  create: 'bg-green-100 text-green-800',
  name_update: 'bg-blue-100 text-blue-800',
  links_update: 'bg-blue-100 text-blue-800',
  discard: 'bg-red-100 text-red-800',
  undiscard: 'bg-green-100 text-green-800',
}

const FIELD_ERROR_CODES = { SALES_CHANNEL_NAME_TAKEN: 'name' }

export const getErrorCode = error => error?.response?.data?.error_code || null

export const getErrorMessage = error => error?.response?.data?.error || null

// Maps a backend 422 to a form field when the error_code is field-scoped,
// so the container can show it inline instead of as a toast.
export const mapFieldError = error => {
  const code = getErrorCode(error)
  return code && FIELD_ERROR_CODES[code] ? { field: FIELD_ERROR_CODES[code], code } : null
}

// Returns the added/removed link objects ({id, name}) for a links_update entry,
// regardless of dimension.
export const getLinkChanges = entry => {
  const changes = entry?.after_change || {}
  const dimension = changes.store_ids ? 'store_ids' : 'warehouse_ids'
  const diff = changes[dimension] || {}
  return { added: diff.added || [], removed: diff.removed || [] }
}
